import { ACTIONS } from './actions';

export const getInitialState = () => ({
  dataByBatch: {},
  loadedByBatch: { 0: false },
  loadingByBatch: { 0: false },
  error: null,
  next: null,
});

export const reducer = (state = getInitialState(), { type, payload }) => {
  switch (type) {
    case ACTIONS.UTI_FQB_FETCH: {
      const updatedLoaded = { ...new Array(payload.batchesAmount).fill(false) };
      const updatedLoading = { ...new Array(payload.batchesAmount).fill(true) };

      return {
        ...getInitialState(),
        loadedByBatch: updatedLoaded,
        loadingByBatch: updatedLoading,
      };
    }
    case ACTIONS.UTI_FQB_FETCH_ERROR: {
      const { error, batchId } = payload;

      // One failing query must not discard the ones that resolved. A caller batching a
      // division query with an organization-wide one (readable only by organization roles)
      // would otherwise end up with nothing at all, and render an empty, disabled input.
      // The failed batch is still marked as settled so `loaded` can become true and the
      // effect does not refetch forever.
      if (batchId == null) {
        return { ...state, error, loadedByBatch: { 0: true }, loadingByBatch: { 0: false } };
      }

      return {
        ...state,
        error,
        loadedByBatch: { ...state.loadedByBatch, [batchId]: true },
        loadingByBatch: { ...state.loadingByBatch, [batchId]: false },
      };
    }
    case ACTIONS.UTI_FQB_FETCH_BATCH_SUCCESS: {
      const { batchId } = payload;

      const updatedData = {
        ...state.dataByBatch,
        [batchId]: { ...state.dataByBatch[batchId], ...payload.data },
      };
      const updatedLoading = {
        ...state.loadingByBatch,
        [batchId]: false,
      };
      const updatedLoaded = {
        ...state.loadedByBatch,
        [batchId]: true,
      };

      return {
        ...getInitialState(),
        dataByBatch: updatedData,
        loadedByBatch: updatedLoaded,
        loadingByBatch: updatedLoading,
      };
    }
    case ACTIONS.UTI_FQB_RESET: {
      return getInitialState();
    }
    default:
      throw new Error('useFirestoreQueryBatched: Invalid action');
  }
};
